"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classKey = exports.studentKey = exports.teacherKey = exports.schoolKey = exports.SchoolEntityTypes = void 0;
var SchoolEntityTypes;
(function (SchoolEntityTypes) {
    SchoolEntityTypes["School"] = "school";
    SchoolEntityTypes["Class"] = "class";
    SchoolEntityTypes["Student"] = "student";
    SchoolEntityTypes["Teacher"] = "teacher";
})(SchoolEntityTypes = exports.SchoolEntityTypes || (exports.SchoolEntityTypes = {}));
const entityKey = (entityType) => (entityId) => `${entityType}-${entityId}`;
exports.schoolKey = entityKey(SchoolEntityTypes.School);
exports.teacherKey = entityKey(SchoolEntityTypes.Teacher);
exports.studentKey = entityKey(SchoolEntityTypes.Student);
exports.classKey = entityKey(SchoolEntityTypes.Class);
//# sourceMappingURL=common.js.map